export default __webpack_public_path__ + "bf70bf312c29f69e6e62f2830a72b6d3.png";